import { CommonContexts, UuiContexts } from '@epam/uui-core'
import { showSuccessNotification } from '../notifications/showSuccessNotification'
import { showModalWindow } from '../common/commonModalComponent/showModalWindow'
import { MESSAGES } from '../../constants/messages'

export const showConfirmPointDeleteModal = (
  svc: CommonContexts<UuiContexts, any>,
  deletePoint?: () => Promise<void>
) => {
  const messages = {
    title: MESSAGES.POINT_DELETE_MODAL.TITLE,
    description: MESSAGES.POINT_DELETE_MODAL.DESCRIPTION,
    successNotification: MESSAGES.POINT_DELETE_MODAL.DELETE_SUCCESS_MSG,
    action: MESSAGES.POINT_DELETE_MODAL.SUCCESS_ACTION,
  }

  return showModalWindow(svc, messages, deletePoint).then((result) =>
    showSuccessNotification({ svc, message: result })
  )
}
